var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMembershipsPause = function SvgMembershipsPause(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0413 -0.2C9.44201 -0.2 8.95027 0.280171 8.98533 0.893207V13.1118C8.97679 13.4616 9.10623 13.7395 9.31654 13.9276C9.52318 14.1125 9.79539 14.2 10.06 14.2C10.3247 14.2 10.5969 14.1125 10.8035 13.9276C11.0138 13.7395 11.1433 13.4616 11.1347 13.1118V0.887204C11.1347 0.282247 10.6507 -0.2 10.0413 -0.2Z",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91886 -0.2C3.34143 -0.2 2.8629 0.287847 2.8629 0.887204V13.1118C2.85436 13.4616 2.9838 13.7395 3.1941 13.9276C3.40075 14.1125 3.67296 14.2 3.9376 14.2C4.20225 14.2 4.47446 14.1125 4.6811 13.9276C4.89141 13.7395 5.02085 13.4616 5.01231 13.1118V0.893185C5.04776 0.269336 4.50651 -0.2 3.91886 -0.2Z",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))));
};
export default SvgMembershipsPause;